// extracted by mini-css-extract-plugin
module.exports = {"inputWrap":"inquiry_inputWrap__NMBjs","required":"inquiry_required__OXYqL"};